import { CHECKOUT_ENVIRONMENT } from '../checkout-environment';

export const getGooglePayEnvironment = (isProduction: boolean): google.payments.api.Environment => {
  return isProduction ? 'PRODUCTION' : 'TEST';
};

export const GOOGLE_PAY_API_VERSION = { apiVersion: 2, apiVersionMinor: 0 };

export const GOOGLE_PAY_PAYMENT_METHOD_SPECIFICATION: google.payments.api.PaymentMethodSpecification[] = [
  {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD']
    },
    tokenizationSpecification: {
      type: 'PAYMENT_GATEWAY',
      parameters: {
        gateway: 'adyen',
        gatewayMerchantId: 'YattaAccount'
      }
    }
  }
];

export const GOOGLE_PAY_MERCHANT_INFO: google.payments.api.MerchantInfo = {
  merchantId: CHECKOUT_ENVIRONMENT.googlePayMerchantId,
  merchantName: 'Yatta Solutions GmbH'
};
